import axiosInstance from "../../../helpers/api";

export const getMarkSchemesBySubject = () => {
  return axiosInstance.get("/admin/mark_schemes/subject");
};

export const createMarkScheme = (formData) => {
  return axiosInstance.post("/admin/mark_schemes", formData);
};

export const registerMarkScheme = (body) => {
  return axiosInstance.post("/admin/mark_schemes/register", body);
};

/**
 * Proxy through Laravel to avoid browser CORS against grader.edutopiaonline.com.
 * Backend should forward to POST https://grader.edutopiaonline.com/api/papers/mark
 */
export const markPaperWithAi = (body) => {
  return axiosInstance.post("/admin/mark_schemes/mark_paper", body);
};
